import {AGENDA_SLOT_DURATION} from "../../common/agenda.constant";

export interface IAgendaUserConfig {
  AgendaStartTime?: number;
  AgendaEndTime?: number;
  AgendaSelectedUsers?: number[];
  AgendaHideIcons?: boolean
  AgendaShowAppointmentTime?: boolean;
  UseNewAgendaCommentNegativeAndPositive?: boolean;
  AgendaSlotDurationMinutes?: string;
  SlotDuration?: number;
  AgendaSharingUsers?: Array<any>;
  AgendaHasSharingUsers?: boolean;
  AgendaTypesRequiredProperty?: string;
  AgendaViewType?: number
}

export class AgendaUserConfig {
  start: string;
  end: string;
  step: string;
  agendaSelectedUsers?: number[];
  AgendaHideIcons?: boolean;
  AgendaShowAppointmentTime?: boolean;
  UseNewAgendaCommentNegativeAndPositive?: boolean;
  AgendaSlotDurationMinutes?: string;
  SlotDuration?: number;
  AgendaSharingUsers?: Array<any>;
  AgendaHasSharingUsers?: boolean;
  AgendaTypesRequiredProperty: string;
  AgendaViewType?: number
  /**
   *
   */
  constructor(option: IAgendaUserConfig) {
    this.start = this.getTime(option.AgendaStartTime);
    this.end = this.getTime(option.AgendaEndTime);
    this.step = '00:15';
    this.agendaSelectedUsers = option.AgendaSelectedUsers;
    this.AgendaHideIcons = option.AgendaHideIcons;
    this.AgendaShowAppointmentTime = option.AgendaShowAppointmentTime;
    this.UseNewAgendaCommentNegativeAndPositive = option.UseNewAgendaCommentNegativeAndPositive || false;
    this.AgendaSlotDurationMinutes = option.AgendaSlotDurationMinutes;
    this.SlotDuration = this.initSlotDuration(option.AgendaSlotDurationMinutes);
    this.AgendaSharingUsers = option.AgendaSharingUsers || [];
    this.AgendaHasSharingUsers = option.AgendaHasSharingUsers;
    this.AgendaTypesRequiredProperty = option.AgendaTypesRequiredProperty;
    this.AgendaViewType = option.AgendaViewType;
  }

  private getTime(hour: number) {
    let time = hour.toString();
    if (time.length <= 1) {
      return `0${time}:00`
    }
    return `${time}:00`
  }

  private initSlotDuration(agendaSlotDurationMinutes: string) {
    if (!agendaSlotDurationMinutes) return 15;
    let slotDuration = Array.from(AGENDA_SLOT_DURATION).find(item => item.KeyValue === agendaSlotDurationMinutes);
    return (slotDuration && slotDuration.label) || 15;
  }
}